import * as React from "react";
import type { SVGProps } from "react";
const SvgSwimmingPool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#swimming-pool_svg__a)">
      <path d="M20.05 22h-.14a3.38 3.38 0 0 1-2.72-1.42A1.49 1.49 0 0 0 16 20a1.4 1.4 0 0 0-1.21.58A3.44 3.44 0 0 1 12 22a3.4 3.4 0 0 1-2.79-1.42A1.47 1.47 0 0 0 8 20a1.41 1.41 0 0 0-1.21.58A3.46 3.46 0 0 1 4 22a3.38 3.38 0 0 1-2.79-1.42 1 1 0 0 1 .23-1.39 1 1 0 0 1 1.39.23A1.39 1.39 0 0 0 4 20a1.54 1.54 0 0 0 1.21-.58A3.52 3.52 0 0 1 8 18a3.49 3.49 0 0 1 2.79 1.42A1.42 1.42 0 0 0 12 20a1.52 1.52 0 0 0 1.21-.58A3.54 3.54 0 0 1 16 18a3.49 3.49 0 0 1 2.79 1.42A1.39 1.39 0 0 0 20 20a1.54 1.54 0 0 0 1.21-.58 1 1 0 0 1 1.39-.23 1 1 0 0 1 .23 1.39A3.39 3.39 0 0 1 20.05 22" />
      <path d="M20.05 18h-.14a3.38 3.38 0 0 1-2.72-1.42A1.49 1.49 0 0 0 16 16a1.4 1.4 0 0 0-1.21.58A3.36 3.36 0 0 1 12 18a3.4 3.4 0 0 1-2.79-1.42A1.47 1.47 0 0 0 8 16a1.41 1.41 0 0 0-1.21.58A3.38 3.38 0 0 1 4 18a3.38 3.38 0 0 1-2.79-1.42 1 1 0 0 1 .23-1.39 1 1 0 0 1 1.39.23A1.39 1.39 0 0 0 4 16a1.54 1.54 0 0 0 1.21-.58A3.5 3.5 0 0 1 8 14a3.41 3.41 0 0 1 2.79 1.42A1.42 1.42 0 0 0 12 16a1.52 1.52 0 0 0 1.21-.58A3.51 3.51 0 0 1 16 14a3.41 3.41 0 0 1 2.79 1.42A1.39 1.39 0 0 0 20 16a1.54 1.54 0 0 0 1.21-.58 1 1 0 0 1 1.39-.23 1 1 0 0 1 .23 1.39A3.39 3.39 0 0 1 20.05 18M15 13a1 1 0 0 1-1-1V4.5A2.5 2.5 0 0 1 16.5 2a1 1 0 1 1 0 2 .5.5 0 0 0-.5.5V12a1 1 0 0 1-1 1M9 13a1 1 0 0 1-1-1V4.5A2.5 2.5 0 0 1 10.5 2a1 1 0 1 1 0 2 .5.5 0 0 0-.5.5V12a1 1 0 0 1-1 1" />
      <path d="M15 7H9a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2M15 11H9a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2" />
    </g>
    <defs>
      <clipPath id="swimming-pool_svg__a">
        <path fill="#fff" d="M1 2h22v20H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwimmingPool;
